import { EnvironmentProviders, Provider } from '@angular/core';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ROUTE_PROCESSOR } from '@frontend/vanilla/core';

import { LazyBootstrapService } from '../lazy-bootstrap.service';
import { RouteProductProcessor } from '../route-processor';
import { provideCMModuleBootstrap, provideCoralCoreBootstrap } from './bootstrap.provider';

export function provideCMHostApp(): (Provider | EnvironmentProviders)[] {
    return [
        LazyBootstrapService,
        {
            provide: ROUTE_PROCESSOR,
            useClass: RouteProductProcessor,
            multi: true,
        },
        provideCoralCoreBootstrap(),
        provideCMModuleBootstrap(),
    ];
}
